import React from 'react';
import { motion } from 'framer-motion';
import type { HomeTopicSectionConfig } from '../homeTopicSections';
import { TopicServiceCardGrid } from './TopicServiceCardGrid';

interface HomeTopicSectionBlockProps {
  section: HomeTopicSectionConfig;
  sectionIndex: number;
  titleRef?: React.RefObject<HTMLHeadingElement | null>;
  comingSoonSection: string | null;
  onViewAll: () => void;
  onSelect: (categoryId: string, slug: string) => void;
}

export const HomeTopicSectionBlock: React.FC<HomeTopicSectionBlockProps> = ({
  section,
  sectionIndex,
  titleRef,
  comingSoonSection,
  onViewAll,
  onSelect,
}) => (
  <div
    id={`home-section-${section.id}`}
    className={sectionIndex > 0 ? 'home-topic-section home-topic-section--spaced' : 'home-topic-section'}
  >
    <motion.div
      className="saas-sec-head"
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
    >
      <div className="saas-sec-head-left">
        <span className={`saas-sec-eyebrow ${section.eyebrowClass ?? ''}`}>
          {section.id === 'emergency' ? <span className="ebento-pulse-dot" /> : null}
          {section.eyebrowIcon ? (
            <i className={`ti ${section.eyebrowIcon}`} style={{ fontSize: 13 }} />
          ) : null}
          {section.eyebrow}
        </span>
        <div className="saas-sec-title-row">
          {section.titleLead ? (
            <h2 ref={titleRef} className="saas-sec-title saas-sec-title--display">
              <span className="saas-sec-title-lead">{section.titleLead}</span>
              {section.titleTail ? (
                <span className="saas-sec-title-tail">{section.titleTail}</span>
              ) : null}
            </h2>
          ) : (
            <h2 ref={titleRef} className="saas-sec-title">
              {section.title}
            </h2>
          )}
          <div className="saas-sec-view-all-wrap">
            <button type="button" className="saas-sec-view-all" onClick={onViewAll}>
              View all <i className="ti ti-arrow-right" style={{ fontSize: 13 }} />
            </button>
            {comingSoonSection === section.comingSoonKey && (
              <div className="coming-soon-popup" style={{ top: '110%', right: 0, left: 'auto', width: 230 }}>
                <div className="coming-soon-popup__inner">
                  <span className="coming-soon-popup__emoji">{section.comingSoonEmoji}</span>
                  <p className="coming-soon-popup__title" style={{ fontSize: '15px' }}>
                    {section.comingSoonTitle}
                  </p>
                  <p className="coming-soon-popup__sub" style={{ fontSize: '13px' }}>
                    {section.comingSoonSub}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
        <p className="saas-sec-sub">{section.subtitle}</p>
      </div>
    </motion.div>

    {section.items.length > 0 ? (
      <TopicServiceCardGrid items={section.items} onSelect={onSelect} />
    ) : null}
  </div>
);
